module.exports = __webpack_public_path__ + "img/angle_210.8ff410d8.jpg";